function isArrayOfType(value: unknown, type: string) {
  return Array.isArray(value) && value.length > 0 && value.every((item) => typeof item === type);
}

export { isArrayOfType };
